import { render } from "./ViewApprovedRequest.vue?vue&type=template&id=6a146dbe"
import script from "./ViewApprovedRequest.vue?vue&type=script&lang=js"
export * from "./ViewApprovedRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__